import { useRef, useCallback, useEffect } from 'react';
export function useDismissableNotification(_a) {
    var id = _a.id, queueName = _a.queueName, duration = _a.duration, removeNotification = _a.removeNotification, onCloseCallback = _a.onCloseCallback;
    var dismissTimeout = useRef();
    var timerExpectedEnd = useRef(0);
    var pauseRemainingTime = useRef(0);
    // we only want to reset the timer when the notification is replaced, so everything below
    // only checks for the id in the memoization
    var onClose = useCallback(function () {
        removeNotification(queueName, id);
        if (onCloseCallback) {
            onCloseCallback();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id]);
    var clearDismissTimeout = useCallback(function () {
        if (!dismissTimeout.current) {
            return;
        }
        clearTimeout(dismissTimeout.current);
        dismissTimeout.current = null;
        timerExpectedEnd.current = 0;
    }, []);
    var setDismissTimeout = useCallback(function (durationOverride) {
        var effectiveDuration = durationOverride === undefined ? duration : durationOverride;
        clearDismissTimeout();
        dismissTimeout.current = setTimeout(onClose, effectiveDuration);
        timerExpectedEnd.current = new Date().getTime() + effectiveDuration;
        pauseRemainingTime.current = 0;
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [id]);
    var onPause = useCallback(function () {
        if (!timerExpectedEnd.current) {
            return;
        }
        pauseRemainingTime.current = Math.max(timerExpectedEnd.current - new Date().getTime(), 0);
        if (pauseRemainingTime.current) {
            clearDismissTimeout();
        }
    }, [clearDismissTimeout]);
    var onUnpause = useCallback(function () {
        if (!pauseRemainingTime.current) {
            return;
        }
        setDismissTimeout(pauseRemainingTime.current);
    }, [setDismissTimeout]);
    useEffect(function () {
        setDismissTimeout();
        return function () { return clearDismissTimeout(); };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id]);
    return { onClose: onClose, onPause: onPause, onUnpause: onUnpause };
}
//# sourceMappingURL=useDismissableNotification.js.map